import {Message} from 'element-ui'

export default {
    warning (msg) {
        Message.warning(msg)
    },
    error (msg) {
        Message.error(msg)
    },
    info (msg) {
        Message.info(msg)
    },
    success (msg) {
        Message.success(msg)
    }
}